import { forIn, cloneDeep, isPlainObject } from 'lodash';
import { Form } from 'antd';

/**
 * 表单域布局设置
 */
export const FormItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

/**
 * 配置表单装饰器
 * @param {*} component
 */
export const ConfigFormDecorator = function(component) {
    return Form.create({
        mapPropsToFields(props) {
            return (function generateFields(source) {
                let fields = {};
                forIn(source, (field, name) => {
                    if (isPlainObject(field)) {
                        fields[name] = generateFields(field);
                    } else {
                        fields[name] = Form.createFormField({
                            value: field,
                        });
                    }
                });
                return fields;
            })(props['value']);
        },
        onValuesChange(props: any, changedValues) {
            const { value, onChange } = props;
            let values = cloneDeep(value);
            (function handleValuesChange(fields, changedValues) {
                forIn(changedValues, (changedValue, fieldName) => {
                    let field = fields[fieldName];
                    if (isPlainObject(field)) {
                        handleValuesChange(field, changedValue);
                    } else {
                        Object.assign(fields, changedValues);
                    }
                });
            })(values, changedValues);
            onChange(values);
        },
    })(component);
};
